import { twc } from 'react-twc';

export const Card = twc.div`flex bg-card-background rounded-lg border-solid border-t border-r-0 border-b-0 border-l-0 border-t-greyscale-dark`;
